import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={140}
      height={140}
      viewBox="0 0 140 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M11.768 117.928c1.771 3.286 5.531 4.696 5.531 4.696s.888-3.916-.884-7.202c-1.771-3.285-5.531-4.696-5.531-4.696s-.888 3.917.884 7.202z"
        fill="#2F2E41"
      />
      <Path
        d="M12.986 116.847c3.198 1.925 4.43 5.747 4.43 5.747s-3.954.702-7.152-1.222c-3.199-1.925-4.43-5.747-4.43-5.747s3.953-.702 7.152 1.222z"
        fill="#E40046"
      />
      <Path
        d="M57.442 116.424H23.69v-.243H57.2v-11.777H26.527l-1.49-3.104.218-.105 1.424 2.966h30.762v12.263z"
        fill="#2F2E41"
      />
      <Path
        d="M28.182 122.373a2.55 2.55 0 100-5.1 2.55 2.55 0 000 5.1zM53.314 122.373a2.55 2.55 0 100-5.1 2.55 2.55 0 000 5.1zM82.938 67.253a1.578 1.578 0 100-3.157 1.578 1.578 0 000 3.157z"
        fill="#3F3D56"
      />
      <Path
        d="M61.052 100.398H23.114l-8.208-26.832h54.6l-.05.158-8.404 26.674zm-37.758-.243h37.58l8.3-26.346h-53.94l8.06 26.346z"
        fill="#2F2E41"
      />
      <Path
        d="M58.09 99.001H24.77l-7.21-23.796h47.956l-.043.14-7.382 23.656z"
        fill="#F1F1F1"
      />
      <Path
        d="M70.186 71.17l-.235-.063 1.603-6.04h9.32v.243h-9.133l-1.555 5.86zM66.777 81.7H17.56v.243h49.218v-.242zM63.959 90.647H20.296v.242h43.663v-.242z"
        fill="#2F2E41"
      />
      <Path
        d="M42.327 73.688h-.243v26.588h.243V73.688zM53.198 73.68l-1.743 26.588.242.016 1.743-26.588-.242-.016zM31.217 73.68l-.242.015 1.733 26.589.242-.016-1.733-26.588zM133.551 122.527H5.833v.285h127.718v-.285z"
        fill="#2F2E41"
      />
      <Path
        d="M90.704 25.153s2.084 5.93.801 6.843c-1.282.913 4.328 8.364 4.328 8.364l6.732-1.825-3.686-6.235s-.481-6.234-.481-7.147c0-.912-7.694 0-7.694 0z"
        fill="#A0616A"
      />
      <Path
        opacity={0.1}
        d="M90.704 25.153s2.084 5.93.801 6.843c-1.282.913 4.328 8.364 4.328 8.364l6.732-1.825-3.686-6.235s-.481-6.234-.481-7.147c0-.912-7.694 0-7.694 0z"
        fill="#000"
      />
      <Path
        d="M87.207 67.428s-.609 7.603 0 11.557c.608 3.954 1.52 14.903 1.52 14.903s0 20.681 3.346 20.985c3.345.304 5.778.608 6.082-.608.305-1.217-1.52-1.825-.608-2.433.913-.609 1.217-2.738 0-5.171-1.216-2.433 0-27.068 0-27.068l5.779 15.511s.608 12.774 1.216 14.599c.609 1.825-.608 5.17 1.521 5.474 2.129.304 4.562-1.521 5.778-2.129 1.217-.608-1.824-.608-1.216-.912.608-.304 2.433-1.217 1.825-1.521-.609-.304-1.217-14.902-1.217-14.902s-1.673-31.174-3.801-32.39c-2.129-1.217-3.498.878-3.498.878l-16.727 3.227z"
        fill="#2F2E41"
      />
      <Path
        d="M92.68 113.656v2.434s-2.736 6.613 0 6.613c2.738 0 4.867.686 4.867-.227v-8.211l-4.866-.609zM110.625 113.652v2.433s2.737 6.614 0 6.614-4.866.685-4.866-.227v-8.212l4.866-.608z"
        fill="#2F2E41"
      />
      <Path
        d="M94.962 29.563a5.475 5.475 0 100-10.95 5.475 5.475 0 000 10.95z"
        fill="#A0616A"
      />
      <Path
        d="M93.29 34.277s1.52 4.562 3.953 3.65l2.433-.913 4.258 29.197s-3.345 4.867-8.212 1.825c-4.866-3.041-2.433-33.759-2.433-33.759z"
        fill="#E40046"
      />
      <Path
        d="M97.547 33.365l1.369-2.89s8.059 3.802 9.276 5.019c1.216 1.216 1.216 3.041 1.216 3.041l-2.129 7.604s.609 16.727.609 17.335c0 .608 2.129 3.954.608 2.737-1.521-1.216-1.825-2.433-3.041-.608-1.217 1.825-3.954 3.954-3.954 3.954l-3.954-36.192z"
        fill="#3F3D56"
      />
      <Path
        d="M108.192 55.263l-.912 8.515s-5.475 4.866-4.258 5.17c1.216.305 1.824-.912 1.824-.912s2.129 2.13 3.346.913c1.217-1.217 4.258-12.774 4.258-12.774l-4.258-.912z"
        fill="#A0616A"
      />
      <Path
        d="M95.079 16.352c-1.214-.044-2.513-.065-3.536.589-.47.328-.884.732-1.222 1.196-.996 1.26-1.858 2.845-1.487 4.408l.43-.167c0 .417-.093.829-.272 1.206.06-.176.263.108.21.287l-.474 1.553c.778-.285 1.747.293 1.865 1.114.054-1.805.242-3.875 1.706-4.931.738-.533 1.672-.696 2.571-.84.83-.134 1.699-.26 2.493.012.795.273 1.471 1.086 1.291 1.906.366-.126.776.13.957.472.181.342.19.746.196 1.134.39.276.835-.272.994-.723.373-1.059.705-2.185.504-3.29-.201-1.103-1.101-2.158-2.223-2.162a.779.779 0 00.203-.549l-.925-.078c.234-.033.45-.147.61-.322-.37.409-3.29-.794-3.891-.815z"
        fill="#2F2E41"
      />
      <Path
        d="M94.81 32.453s-2.476-2.427-3.367-2.278c-.891.148-2.108 2.277-2.108 2.277s-7.299 2.434-6.995 4.867c.304 2.433 3.65 14.294 3.65 14.294s2.737 14.294.304 15.815c-2.433 1.52 11.557 5.474 11.861 3.65.304-1.825.913-20.073 0-22.81-.912-2.738-3.345-15.816-3.345-15.816zM105.455 37.319h3.76s2.627 11.557 2.931 12.773c.304 1.217.912 6.995.608 6.995-.304 0-6.387-1.216-6.387-.304l-.912-19.464z"
        fill="#3F3D56"
      />
      <Path
        d="M105.327 65.938H90.93c-1.405-6.463-1.522-12.707 0-18.673h14.397c-2.323 5.858-2.468 12.06 0 18.673z"
        fill="#F2F2F2"
      />
      <Path
        d="M85.078 58l4.257 1.825s8.212 1.216 8.212-2.13c0-3.345-8.212-1.52-8.212-1.52l-2.737-.875-1.52 2.7z"
        fill="#A0616A"
      />
      <Path
        d="M85.99 35.494l-3.65.912-2.737 16.12s-.912 4.257.609 4.561c1.52.304 5.778 2.738 5.778 2.738s.608-4.562 1.825-4.562l-3.041-2.433 1.824-10.645-.608-6.691z"
        fill="#3F3D56"
      />
    </Svg>
  );
}

export default SvgComponent;
